export const ROOT = '/';

export const CONTRACTS = `/contracts`;
export const CONTRACTS_ADD = `/contracts/add`;
export const CONTRACTS_ALL = `/contracts/all`;
export const CONTRACT_DETAIL = `/contracts/:contractId`;
export const CONTRACT_LINEITEM_DETAIL = `/contracts/:contractId/products/:lineItemId`;
export const CONTRACT_VALIDATE = `/contracts/:contractId/validate`;
export const CONTRACT_ADD_AOAS = `/contracts/:contractId/area-of-access`;
export const CONTRACT_ADD_USERS = `/contracts/:contractId/add-users`;

export const DASHBOARD = '/dashboard';

export const LABS = '/labs';

export const ORDERS = '/orders';
export const ORDER_DETAIL = '/orders/:orderId';

export const ORGS = '/organizations';
export const ORG_DETAIL = '/organizations/:orgId';
export const ORG_AOA = '/organizations/:orgId/areas-of-access';
export const ORG_GENERAL = '/organizations/:orgId/general';
export const ORG_PLANS = '/organizations/:orgId/plans';
export const ORG_PLAN_TASKING = '/organizations/:orgId/plans/tasking';
export const ORG_PLAN_TASKING_DETAIL =
  '/organizations/:orgId/plans/tasking/:plNumber';
export const ORG_PLAN_DETAIL = '/organizations/:orgId/plans/:planId';
export const ORG_SUBORGS = '/organizations/:orgId/suborgs';
export const ORG_USERS = '/organizations/:orgId/users';

export const PLANS = '/plans';
export const PLAN_DETAIL = '/plans/:planId';
export const PLAN_CONTRACTS = '/plans/contract';
export const PLAN_CONTRACT_DETAIL = `/plans/contract/:contractId`;
export const PLAN_CONTRACT_LINEITEM_DETAIL = `/plans/contract/:contractId/product/:lineItemId`;
export const PLAN_TASKING = '/plans/tasking';
export const PLAN_TASKING_DETAIL = `/plans/tasking/:plNumber`;

export const SENTINEL_HUB_CALLBACK = `/sh-callback`;
export const SENTINEL_HUB_REDIRECT = `/sh-redirect`;

export const USERS = '/users';
export const USER_DETAIL = '/users/:userId';
export const USER_SETTINGS = '/user-settings';

const routes = {
  ROOT,
  CONTRACTS,
  CONTRACTS_ADD,
  CONTRACTS_ALL,
  CONTRACT_DETAIL,
  CONTRACT_LINEITEM_DETAIL,
  CONTRACT_VALIDATE,
  CONTRACT_ADD_AOAS,
  CONTRACT_ADD_USERS,
  DASHBOARD,
  LABS,
  ORDERS,
  ORDER_DETAIL,
  ORGS,
  ORG_DETAIL,
  ORG_AOA,
  ORG_GENERAL,
  ORG_PLANS,
  ORG_PLAN_TASKING,
  ORG_PLAN_TASKING_DETAIL,
  ORG_PLAN_DETAIL,
  ORG_SUBORGS,
  ORG_USERS,
  PLANS,
  PLAN_DETAIL,
  PLAN_CONTRACTS,
  PLAN_CONTRACT_DETAIL,
  PLAN_CONTRACT_LINEITEM_DETAIL,
  PLAN_TASKING,
  PLAN_TASKING_DETAIL,
  SENTINEL_HUB_CALLBACK,
  SENTINEL_HUB_REDIRECT,
  USERS,
  USER_DETAIL,
  USER_SETTINGS,
};

export default routes;
